import { create } from 'zustand'

type CookieConsentBannerStore = {
  isCookiesBannerVisible: boolean
  setIsCookiesBannerVisible: (isVisible: boolean) => void
}

export const useCookieConsentBannerStore = create<CookieConsentBannerStore>(
  (set) => ({
    isCookiesBannerVisible: false,
    setIsCookiesBannerVisible: (isVisible) =>
      set({ isCookiesBannerVisible: isVisible }),
  }),
)
